export const initialTasks = [
  {
    id: 'custom-1',
    text: 'Hire a dedicated Operations Manager',
    category: 'Operations',
    source: 'User Created',
    status: 'todo',
    priority: 'High',
    dueDate: '2024-03-15',
    createdAt: '2024-01-20'
  },
  {
    id: 'custom-2',
    text: 'Renew annual insurance policies',
    category: 'Finance',
    source: 'User Created',
    status: 'in-progress',
    priority: 'Medium',
    dueDate: '2024-02-28',
    createdAt: '2024-01-22'
  }
];

export const taskCategories = [
  'Strategy',
  'Operations',
  'Finance',
  'Marketing',
  'Sales',
  'Human Resources',
  'Technology'
];